// Merkezi route yapılandırması
import React from "react";

// Lazy loading için import'lar
const Dashboard = React.lazy(() => import("./modules/dashboard/Dashboard"));

// Settings
const CompanyProfilePage = React.lazy(() => import("./modules/settings/CompanyProfile/CompanyProfilePage"));
const CountryList = React.lazy(() => import("./modules/settings/Country/CountryList"));
const CityList = React.lazy(() => import("./modules/settings/City/CityList"));
const RoleList = React.lazy(() => import("./modules/settings/Role/RoleList"));
const UnitGroupList = React.lazy(() => import("./modules/settings/Unit/UnitGroupList"));
const UnitList = React.lazy(() => import("./modules/settings/Unit/UnitList"));
const HospitalList = React.lazy(() => import("./modules/settings/Hospital/HospitalList"));
const DoctorList = React.lazy(() => import("./modules/settings/Doctor/DoctorList"));
const NumerateTemplateList = React.lazy(() => import("./modules/settings/Numerate/NumerateTemplateList"));

// Financial
const CurrencyList = React.lazy(() => import("./modules/financial/Currency/CurrencyList"));
const ExchangeRatesList = React.lazy(() => import("./modules/financial/Exchange Rates/ExchangeRatesList"));
const CustomerList = React.lazy(() => import("./modules/financial/Customer/CustomerList"));
const CustomerGroupsList = React.lazy(() => import("./modules/financial/Customer/CustomerGroupsList"));
const BankCardsList = React.lazy(() => import("./modules/financial/BankCards/BankCardsList"));
const BankBranchesList = React.lazy(() => import("./modules/financial/BankBranches/BankBranchesList"));
const BankAccountList = React.lazy(() => import("./modules/financial/BankAccount/BankAccountList"));
const BankManagement = React.lazy(() => import("./modules/financial/BankManagement/BankManagement"));
const CashBoxList = React.lazy(() => import("./modules/financial/CashBox/CashBoxList"));
const SectorList = React.lazy(() => import("./modules/financial/sectors/SectorList"));
const SubSectorList = React.lazy(() => import("./modules/financial/sectors/SubSectorList"));
const ExpenseList = React.lazy(() => import("./modules/financial/Expense/ExpenseList"));

// Financial Transactions
const BankOpeningList = React.lazy(() => import("./modules/financial/Transactions/OpeningClosingTransactions/BankOpening/BankOpeningList"));
const BankClosingList = React.lazy(() => import("./modules/financial/Transactions/OpeningClosingTransactions/BankClosing/BankClosingList"));
const CashBoxOpeningList = React.lazy(() => import("./modules/financial/Transactions/OpeningClosingTransactions/CashBoxOpening/CashBoxOpeningList"));
const CashBoxClosingList = React.lazy(() => import("./modules/financial/Transactions/OpeningClosingTransactions/CashBoxClosing/CashBoxClosingList"));
const CustomerOpeningList = React.lazy(() => import("./modules/financial/Transactions/OpeningClosingTransactions/CustomerOpening/CustomerOpeningList"));
const CustomerClosingList = React.lazy(() => import("./modules/financial/Transactions/OpeningClosingTransactions/CustomerClosing/CustomerClosingList"));
const PurchaseInvoiceList = React.lazy(() => import("./modules/financial/Transactions/PurchaseAndReturnTransactions/Purchase/PurchaseInvoiceList"));
const PurchaseReturnInvoiceList = React.lazy(() => import("./modules/financial/Transactions/PurchaseAndReturnTransactions/PurchaseReturn/PurchaseReturnInvoiceList"));
const SaleInvoiceList = React.lazy(() => import("./modules/financial/Transactions/SaleAndReturnTransactions/Sale/SaleInvoiceList"));
const SaleReturnInvoiceList = React.lazy(() => import("./modules/financial/Transactions/SaleAndReturnTransactions/SaleReturn/SaleReturnInvoiceList"));
const InvoiceList = React.lazy(() => import("./modules/financial/Invoice/InvoiceList"));
const BankToBankList = React.lazy(() => import("./modules/financial/Transactions/Virman/bank/BankToBankList"));
const CustomerToCustomerList = React.lazy(() => import("./modules/financial/Transactions/Virman/customer/CustomerToCustomerList"));
const CashToCashList = React.lazy(() => import("./modules/financial/Transactions/Virman/cashbox/CashToCashList"));
const BankToCustomerList = React.lazy(() => import("./modules/financial/Transactions/PaymentCollection/BankToCustomer/BankToCustomerList"));
const CustomerToBankList = React.lazy(() => import("./modules/financial/Transactions/PaymentCollection/CustomerToBank/CustomerToBankList"));
const CustomerToCashList = React.lazy(() => import("./modules/financial/Transactions/PaymentCollection/CustomerToCash/CustomerToCashList"));
const CashToCustomerList = React.lazy(() => import("./modules/financial/Transactions/PaymentCollection/CashToCustomer/CashToCustomerList"));
const BankToCashList = React.lazy(() => import("./modules/financial/Transactions/Exchange/BankToCash/BankToCashList"));
const CashToBankList = React.lazy(() => import("./modules/financial/Transactions/Exchange/CashToBank/CashToBankList"));
const BankTransactionsList = React.lazy(() => import("./modules/financial/Transactions/BankTransactionsList"));
const CustomerTransactionsList = React.lazy(() => import("./modules/financial/Transactions/CustomerTransactionsList"));
const CashboxTransactionsList = React.lazy(() => import("./modules/financial/Transactions/CashboxTransactionsList"));

// Item/Stock
const ItemList = React.lazy(() => import("./modules/item/Item/ItemList"));
const StockCategories = React.lazy(() => import("./modules/item/StockCategories/StockCategoriesList"));
const StockGroups = React.lazy(() => import("./modules/item/StockGroups/StockGroupsList"));
const SubStockGroups = React.lazy(() => import("./modules/item/SubStockGroups/SubStockGroupsList"));
const Producer = React.lazy(() => import("./modules/item/Producer/ProducerList"));
const WareHouse = React.lazy(() => import("./modules/item/WareHouse/WareHouseList"));
const PrescriptionList = React.lazy(() => import("./modules/item/Prescription/PrescriptionList"));
const QuickSaleList = React.lazy(() => import("./modules/item/QuickSale/QuickSaleList"));
const PriceList = React.lazy(() => import("./modules/item/PriceList/PriceList"));
const ModelList = React.lazy(() => import("./modules/item/Producer/Model/ModelList"));

// Stock Transactions
const CountList = React.lazy(() => import("./modules/stocktransaction/Count/CountList"));
const PurchaseList = React.lazy(() => import("./modules/stocktransaction/Purchase/PurchaseList"));
const SalesList = React.lazy(() => import("./modules/stocktransaction/Sales/SalesList"));
const CountDiffList = React.lazy(() => import("./modules/stocktransaction/CountDiff/CountDiffList"));
const SalesReturnList = React.lazy(() => import("./modules/stocktransaction/SalesReturn/SalesReturnList"));
const PurchaseReturnList = React.lazy(() => import("./modules/stocktransaction/PurchaseReturn/PurchaseReturnList"));
const SerialCodeList = React.lazy(() => import("./modules/stocktransaction/SerialCode/SerialCodeList"));
const SerialCodesList = React.lazy(() => import("./modules/stocktransaction/SerialCodes/SerialCodesList"));
const TransferList = React.lazy(() => import("./modules/stocktransaction/Transfer/TransferList"));

// Order Transactions
const PurchaseOrderList = React.lazy(() => import("./modules/ordertransaction/PurchaseOrder/PurchaseOrderList"));
const SalesOrderList = React.lazy(() => import("./modules/ordertransaction/SalesOrder/SalesOrderList"));

// Users
const DepartmentList = React.lazy(() => import("./modules/users/Department/DepartmentList"));
const TitleList = React.lazy(() => import("./modules/users/Title/TitleList"));
const BranchList = React.lazy(() => import("./modules/users/Branch/BranchList"));
const EmployeeList = React.lazy(() => import("./modules/users/Employee/EmployeeList"));

// Commission - Prim Yönetimi
const CommissionRuleList = React.lazy(() => import("./modules/commission/CommissionRules/CommissionRuleList"));
const SalesTargetList = React.lazy(() => import("./modules/commission/SalesTargets/SalesTargetList"));
const CommissionList = React.lazy(() => import("./modules/commission/Commissions/CommissionList"));
const CommissionPaymentList = React.lazy(() => import("./modules/commission/Payments/CommissionPaymentList"));
const CommissionReports = React.lazy(() => import("./modules/commission/Reports/CommissionReports"));

// Reports
const DailySalesReport = React.lazy(() => import("./modules/reports/DailySalesReport"));
const MonthlySalesReport = React.lazy(() => import("./modules/reports/MonthlySalesReport"));
const CustomerSalesDetailReport = React.lazy(() => import("./modules/reports/CustomerSalesDetailReport"));
const CategorySalesAnalysisReport = React.lazy(() => import("./modules/reports/CategorySalesAnalysisReport"));
const EmployeePerformanceReport = React.lazy(() => import("./modules/reports/EmployeePerformanceReport"));
const CurrentStockStatusReport = React.lazy(() => import("./modules/reports/CurrentStockStatusReport"));
const StockMovementReport = React.lazy(() => import("./modules/reports/StockMovementReport"));
const CashMovementReport = React.lazy(() => import("./modules/reports/CashMovementReport"));
const BankMovementReport = React.lazy(() => import("./modules/reports/BankMovementReport"));

// UTS
const UtsTakingPage = React.lazy(() => import("./modules/uts/pages/UtsTakingPage"));
const UtsGivingPage = React.lazy(() => import("./modules/uts/pages/UtsGivingPage"));
// const UtsReceivedPage = React.lazy(() => import("./modules/uts/pages/UtsReceivedPage"));
const UtsStockPage = React.lazy(() => import("./modules/uts/pages/UtsStockPage"));
const UtsArchivePage = React.lazy(() => import("./modules/uts/pages/UtsArchivePage"));

/**
 * Route yapılandırması
 * Her route için path ve component tanımı
 */
export const routes = [
    // Dashboard
    { path: "/", element: <Dashboard />, key: "dashboard" },
    { path: "/dashboard", element: <Dashboard />, key: "dashboard" },

    // Settings - Ayarlar
    { path: "/company-profile", element: <CompanyProfilePage />, key: "company-profile" },
    { path: "/country", element: <CountryList />, key: "country" },
    { path: "/city", element: <CityList />, key: "city" },
    { path: "/roles", element: <RoleList />, key: "roles" },
    { path: "/unit-group", element: <UnitGroupList />, key: "unit-group" },
    { path: "/unit", element: <UnitList />, key: "unit" },
    { path: "/hospital", element: <HospitalList />, key: "hospital" },
    { path: "/doctor", element: <DoctorList />, key: "doctor" },
    { path: "/numerate-templates", element: <NumerateTemplateList />, key: "numerate-templates" },

    // Financial - Finans Tanımları
    { path: "/currency", element: <CurrencyList />, key: "currency" },
    { path: "/exchange-rate", element: <ExchangeRatesList />, key: "exchange-rate" },
    { path: "/customer", element: <CustomerList />, key: "customer" },
    { path: "/customer-group", element: <CustomerGroupsList />, key: "customer-group" },
    { path: "/bankcards", element: <BankCardsList />, key: "bankcards" },
    { path: "/bankbranches", element: <BankBranchesList />, key: "bankbranches" },
    { path: "/bankaccount", element: <BankAccountList />, key: "bankaccount" },
    { path: "/bank-management", element: <BankManagement />, key: "bank-management" },
    { path: "/cashbox", element: <CashBoxList />, key: "cashbox" },
    { path: "/sector", element: <SectorList />, key: "sector" },
    { path: "/subsector", element: <SubSectorList />, key: "subsector" },
    { path: "/expense", element: <ExpenseList />, key: "expense" },

    // Financial Transactions - Finans Hareketleri
    { path: "/bank-opening", element: <BankOpeningList />, key: "bank-opening" },
    { path: "/bank-closing", element: <BankClosingList />, key: "bank-closing" },
    { path: "/cashbox-opening", element: <CashBoxOpeningList />, key: "cashbox-opening" },
    { path: "/cashbox-closing", element: <CashBoxClosingList />, key: "cashbox-closing" },
    { path: "/customer-opening", element: <CustomerOpeningList />, key: "customer-opening" },
    { path: "/customer-closing", element: <CustomerClosingList />, key: "customer-closing" },
    { path: "/purchase-invoice", element: <PurchaseInvoiceList />, key: "purchase-invoice" },
    { path: "/purchase-return-invoice", element: <PurchaseReturnInvoiceList />, key: "purchase-return-invoice" },
    { path: "/sale-invoice", element: <SaleInvoiceList />, key: "sale-invoice" },
    { path: "/sale-return-invoice", element: <SaleReturnInvoiceList />, key: "sale-return-invoice" },
    { path: "/invoice", element: <InvoiceList />, key: "invoice" },
    { path: "/bank-to-bank", element: <BankToBankList />, key: "bank-to-bank" },
    { path: "/customer-to-customer", element: <CustomerToCustomerList />, key: "customer-to-customer" },
    { path: "/cash-to-cash", element: <CashToCashList />, key: "cash-to-cash" },
    { path: "/bank-to-customer", element: <BankToCustomerList />, key: "bank-to-customer" },
    { path: "/customer-to-bank", element: <CustomerToBankList />, key: "customer-to-bank" },
    { path: "/customer-to-cash", element: <CustomerToCashList />, key: "customer-to-cash" },
    { path: "/cash-to-customer", element: <CashToCustomerList />, key: "cash-to-customer" },
    { path: "/bank-to-cash", element: <BankToCashList />, key: "bank-to-cash" },
    { path: "/cash-to-bank", element: <CashToBankList />, key: "cash-to-bank" },
    { path: "/bank-transactions", element: <BankTransactionsList />, key: "bank-transactions" },
    { path: "/customer-transactions", element: <CustomerTransactionsList />, key: "customer-transactions" },
    { path: "/cashbox-transactions", element: <CashboxTransactionsList />, key: "cashbox-transactions" },

    // Item/Stock - Stok Yönetimi
    { path: "/items", element: <ItemList />, key: "item" },
    { path: "/stockcategories", element: <StockCategories />, key: "stockcategories" },
    { path: "/stockgroups", element: <StockGroups />, key: "stockgroups" },
    { path: "/substockgroups", element: <SubStockGroups />, key: "substockgroups" },
    { path: "/producer", element: <Producer />, key: "producer" },
    { path: "/warehouse", element: <WareHouse />, key: "warehouse" },
    { path: "/prescription", element: <PrescriptionList />, key: "prescription" },
    { path: "/quick-sale", element: <QuickSaleList />, key: "quick-sale" },
    { path: "/price-list", element: <PriceList />, key: "price-list" },
    { path: "/model", element: <ModelList producerId={null} />, key: "model" },

    // Stock Transactions - Stok Hareketleri
    { path: "/count", element: <CountList />, key: "count" },
    { path: "/purchase", element: <PurchaseList />, key: "purchase" },
    { path: "/sales", element: <SalesList />, key: "sales" },
    { path: "/purchasereturn", element: <PurchaseReturnList />, key: "purchasereturn" },
    { path: "/salesreturn", element: <SalesReturnList />, key: "salesreturn" },
    { path: "/countdiff", element: <CountDiffList />, key: "countdiff" },
    { path: "/serialcode", element: <SerialCodeList />, key: "serialcode" },
    { path: "/serialcodes", element: <SerialCodesList />, key: "serialcodes" },
    { path: "/transfer", element: <TransferList />, key: "transfer" },

    // Order Transactions - Sipariş İşlemleri
    { path: "/purchaseorder", element: <PurchaseOrderList />, key: "purchaseorder" },
    { path: "/salesorder", element: <SalesOrderList />, key: "salesorder" },

    // Users - Kullanıcı Yönetimi
    { path: "/department", element: <DepartmentList />, key: "department" },
    { path: "/title", element: <TitleList />, key: "title" },
    { path: "/branch", element: <BranchList />, key: "branch" },
    { path: "/employee", element: <EmployeeList />, key: "employee" },

    // Commission - Prim Yönetimi
    { path: "/commission-rules", element: <CommissionRuleList />, key: "commission-rules" },
    { path: "/sales-targets", element: <SalesTargetList />, key: "sales-targets" },
    { path: "/commissions", element: <CommissionList />, key: "commissions" },
    { path: "/commission-payments", element: <CommissionPaymentList />, key: "commission-payments" },
    { path: "/commission-reports", element: <CommissionReports />, key: "commission-reports" },

    // Reports - Raporlar
    { path: "/daily-sales-report", element: <DailySalesReport />, key: "daily-sales-report" },
    { path: "/monthly-sales-report", element: <MonthlySalesReport />, key: "monthly-sales-report" },
    { path: "/customer-sales-detail-report", element: <CustomerSalesDetailReport />, key: "customer-sales-detail-report" },
    { path: "/category-sales-analysis-report", element: <CategorySalesAnalysisReport />, key: "category-sales-analysis-report" },
    { path: "/employee-performance-report", element: <EmployeePerformanceReport />, key: "employee-performance-report" },
    { path: "/current-stock-status-report", element: <CurrentStockStatusReport />, key: "current-stock-status-report" },
    { path: "/stock-movement-report", element: <StockMovementReport />, key: "stock-movement-report" },
    { path: "/cash-movement-report", element: <CashMovementReport />, key: "cash-movement-report" },
    { path: "/bank-movement-report", element: <BankMovementReport />, key: "bank-movement-report" },

    // UTS
    { path: "/uts-taking", element: <UtsTakingPage />, key: "uts-taking" },
    { path: "/uts-giving", element: <UtsGivingPage />, key: "uts-giving" },
    // { path: "/uts-received", element: <UtsReceivedPage />, key: "uts-received" },
    { path: "/uts-stock-list", element: <UtsStockPage />, key: "uts-stock-list" },
    { path: "/uts-archive", element: <UtsArchivePage />, key: "uts-archive" },
];

/**
 * Key'den path'e dönüşüm için yardımcı fonksiyon
 * @param {string} key - Menu key
 * @returns {string} - Route path
 */
export const getPathFromKey = (key) => {
    const route = routes.find(r => r.key === key);
    return route ? route.path : "/";
};

/**
 * Path'den key'e dönüşüm için yardımcı fonksiyon
 * @param {string} path - Route path
 * @returns {string} - Menu key
 */
export const getKeyFromPath = (path) => {
    const route = routes.find(r => r.path === path);
    return route ? route.key : "dashboard";
};
